import React from 'react'

import { generatePath, NavLink } from 'react-router-dom'
import { Nav, Navbar } from 'rsuite'
import { AddOutline } from 'react-ionicons'

import CatalogTopMenu from '@components/catalog/CatalogTopMenu'
import ProductAttributeGrid from '@components/catalog/productAttribute/ProductAttributeGrid'

import { usePartner } from '@@partner:helpers/hooks/auth'

import { ROUTE_PRODUCT_ATTRIBUTES_ADD } from '@@partner:config/routes'

export default function ProductAttributesPage () {
  const { brandSlug } = usePartner()

  return (
    <div className="ProductAttributesPage">
      <h1 className="u-heading">Группы товаров</h1>
      <CatalogTopMenu />
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<AddOutline />}
            as={NavLink}
            to={generatePath(ROUTE_PRODUCT_ATTRIBUTES_ADD, {
              brandSlug
            })}
          >
             Добавить атрибут
          </Nav.Item>
        </Nav>
      </Navbar>
      <ProductAttributeGrid brandSlug={brandSlug} />
    </div>
  )
}